"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanSanitizer = void 0;
const BooleanSanitizer = (value) => {
    return value === 'true' || value === '1';
};
exports.BooleanSanitizer = BooleanSanitizer;
